var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInProgress = function SvgInProgress(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 46,
    viewBox: "0 0 40 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M20 0L39.9186 11.5V34.5L20 46L0.0814152 34.5V11.5L20 0Z",
    fill: "#004ECC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0007 15.5C15.8585 15.5 12.5007 18.8579 12.5007 23C12.5007 23.2047 12.5089 23.4073 12.5249 23.6075L13.7575 22.0298L15.3335 23.2612L12.7216 26.6043C12.3816 27.0395 11.7531 27.1167 11.3179 26.7767L7.97461 24.1647L9.2059 22.5887L10.5203 23.6156C10.5073 23.412 10.5007 23.2067 10.5007 23C10.5007 17.7533 14.754 13.5 20.0007 13.5C22.9034 13.5 25.5028 14.8031 27.2438 16.8526L25.7195 18.1474C24.3423 16.5261 22.2918 15.5 20.0007 15.5Z",
    fill: "#004ECC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.481 22.3843L30.7955 23.4112L32.0267 21.8351L28.6835 19.2232C28.2483 18.8832 27.6198 18.9604 27.2798 19.3956L24.6678 22.7387L26.2438 23.9701L27.4765 22.3924C27.4925 22.5927 27.5007 22.7953 27.5007 23C27.5007 27.1421 24.1428 30.5 20.0007 30.5C17.7096 30.5 15.6591 29.4739 14.2819 27.8526L12.7576 29.1474C14.4986 31.1969 17.098 32.5 20.0007 32.5C25.2474 32.5 29.5007 28.2467 29.5007 23C29.5007 22.7932 29.4941 22.5879 29.481 22.3843Z",
    fill: "#004ECC"
  })));
};
export { SvgInProgress as ReactComponent };
export default __webpack_public_path__ + "assets/70b7fedd.svg";